import styles from '../../marketplace.module.css'

import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import type {IndexModelsPayload} from '../../types'

import {Box, Label, Link, PageLayout, Text} from '@primer/react'
import MarketplaceHeader from '../../components/MarketplaceHeader'
import MarketplaceNavigation from '../../components/MarketplaceNavigation'
import ModelItem from '../../components/models/ModelItem'
import {Dialog} from '@primer/react/experimental'
import {useState} from 'react'

export function IndexModels() {
  const payload = useRoutePayload<IndexModelsPayload>()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <MarketplaceHeader />
      <PageLayout>
        <PageLayout.Pane position="start">
          <MarketplaceNavigation categories={payload.categories} />
        </PageLayout.Pane>
        <PageLayout.Content as="div">
          <div className="d-flex flex-column flex-sm-row flex-justify-between flex-wrap gap-2">
            <div>
              <h2 className="f2 lh-condensed">Models</h2>
              <p className="fgColor-muted mb-0">
                Try, test, and deploy from a wide range of model types, sizes, and specializations.{' '}
                <Link inline as="button" onClick={() => setIsOpen(true)}>
                  Learn more
                </Link>
                .
              </p>
            </div>

            {isOpen && (
              <Dialog
                width="xlarge"
                onClose={() => setIsOpen(false)}
                renderHeader={() => (
                  <Dialog.Header sx={{display: 'flex'}}>
                    <Box sx={{p: 3}}>
                      <Text as="h2" sx={{pb: 2}}>
                        Responsible use of GitHub Models
                      </Text>
                      <Text as="h5" sx={{color: 'fg.muted'}}>
                        Learn how to use GitHub Models responsibly by understanding its purposes, capabilities, and
                        limitations.
                      </Text>
                    </Box>
                    <Dialog.CloseButton onClose={() => setIsOpen(false)} />
                  </Dialog.Header>
                )}
                renderBody={() => {
                  return (
                    <Box sx={{p: 4}}>
                      <Text as="p">
                        With GitHub Models, you build your understanding of AI model capabilities by experimenting with
                        model settings and sending prompts through a chat interface. Additionally, you can directly
                        interact with models through an SDK. Refer to a model&apos;s &quot;Getting Started&quot; tab for
                        more information about how to use the SDK. Refer to a model&apos;s &quot;README&quot; tab for
                        more information on the model. Remember when interacting with a model you are experimenting with
                        AI, so content mistakes are possible. <br />
                      </Text>

                      <Text as="p">
                        GitHub Models is designed to allow for learning, experimentation and proof-of-concept
                        activities. The feature is subject to various limits (including requests per minute, requests
                        per day, tokens per request, and concurrent requests) and is not designed for production use
                        cases. GitHub Models employs a number of content filters. These filters cannot be turned off as
                        part of the GitHub Models experience. If you decide to employ models through a paid service,
                        please configure your content filters to meet your requirements.
                      </Text>
                    </Box>
                  )
                }}
              />
            )}
            <div className="d-flex flex-items-center gap-2">
              <Label variant="success">Beta</Label>
              <Link href="https://gh.io/models-feedback">Give feedback</Link>
            </div>
          </div>

          <div className={`mt-4 ${styles['marketplace-list-grid']}`}>
            {payload.models?.map(model => <ModelItem key={model.name} model={model} />)}
          </div>
        </PageLayout.Content>
      </PageLayout>
    </>
  )
}

try{ IndexModels.displayName ||= 'IndexModels' } catch {}